import { TimetablePeriod } from '@app/pcs/models';
import { isAfter, today } from '@util/date-util';
import * as R from 'ramda';

export const TIMETABLE_PERIODS_PATH = 'timetable-periods';

type CreateTimetablePeriod = (id: number) => TimetablePeriod;
export const createTimetablePeriod: CreateTimetablePeriod = id => ({id});

type CanEditTimetablePeriod = (timetablePeriod: TimetablePeriod) => boolean;
export const canEditTimetablePeriod: CanEditTimetablePeriod = timetablePeriod => {
  const {activeForDossierCreation, startDossierCreation} = timetablePeriod;
  const activeForDossierCreationInFuture = startDossierCreation && isAfter(startDossierCreation, today());
  return activeForDossierCreation || activeForDossierCreationInFuture;
};

type FilterTimetablePeriodsForCarryForward = (timetablePeriods: TimetablePeriod[]) => TimetablePeriod[];
export const filterTimetablePeriodsForCarryForward: FilterTimetablePeriodsForCarryForward = (timetablePeriods: TimetablePeriod[]) =>
  R.filter((currentTtp: TimetablePeriod) => {
    const nextTtp: TimetablePeriod = R.find(R.propEq('id', currentTtp.id + 1))(timetablePeriods) as TimetablePeriod;
    return nextTtp && nextTtp.activeForDossierCreation;
  }, timetablePeriods);
